import React from "react";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from "@material-ui/styles";
const useStyle = makeStyles({
    formControl:{
        marginBottom: 16,
        minWidth: 120,
        width:"100%"
    }
});
const SelectBoxForMaker = (props) => {
    const classes = useStyle();
    return(
        <FormControl className = {classes.formControl}>
            <InputLabel>{props.label}</InputLabel>
            <Select
                required={props.required} value={props.value}
                onChange={(event=> props.select(event.target.value))}
            >
                {props.options.map((option)=>(
                    <MenuItem key={option.id} value={option.mid}>{option.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default SelectBoxForMaker;